import { formatDateTime } from "common/utils";
import i18n from "features/parent/i18n";
import { ParentPieceComment } from "features/parent/types";

export const ParentPieceCommentRow = ({
  comment,
  onClick,
}: {
  comment: ParentPieceComment;
  onClick?: () => void;
}) => (
  <div
    onClick={onClick}
    className={`flex-col-el w-full gap-1 p-4 rounded-[12px] bg-gray2-20 box-border ${
      onClick ? "cursor-pointer hover:bg-gray2-30 transition-all" : ""
    }`}
  >
    <div className="flex-row-el items-center justify-between w-full gap-2">
      <div className="flex-row-el items-center gap-1 min-w-0">
        <span className="material-symbols-outlined text-[21px] text-red-100">extension</span>
        <span className="text-body text-body-ellipsis text-[21px] text-textcolor-black">
          {comment.piece_name ?? ""}
        </span>
        {/* 通報などで非表示になったコメントは、その旨も出す */}
        {comment.status !== "VISIBLE" && (
          <span className="text-[15px] text-white px-2 rounded-full bg-gray2-100 shrink-0">
            {i18n.t("MSG_PARENT_PAGE_PLAYER_PIECE_COMMENT_HIDDEN")}
          </span>
        )}
      </div>
      <span className="text-[18px] text-gray2-100 shrink-0">
        {formatDateTime(comment.created_at)}
      </span>
    </div>
    <p className="text-[21px] text-textcolor-black whitespace-pre-wrap break-all">
      {comment.content}
    </p>
  </div>
);
